<template>
    <!-- 老系统的行业4层选项，外省分公司需要用到 -->
    <a-cascader :getPopupContainer="(triggerNode) => triggerNode.parentNode" @change="handleChange"
        v-model:value="state.cascaderValue" :style="{ width: props.width }" placeholder="请选择所属行业"
        :field-names="{ label: 'name', value: 'value', children: 'children' }" :options="state.options"
        :load-data="loadData"></a-cascader>
</template>
<script lang="ts" setup>
import { reactive, watch, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
const props = defineProps({
    value: {
        type: String,
        default: ''
    },
    width: {
        type: String,
        default: '100%'
    }
})
const emit = defineEmits(['update:value', 'change'])
interface options2 {
    children: object[]
}
interface options {
    children: options2[]
}
interface state {
    options: options[]
    cascaderValue: number[]
}
const state = reactive<state>({
    options: [],
    cascaderValue: []
})
watch(
    () => props.value,
    (val) => {
        // 如果进来的值和返回的值一样 直接ruturn 防止重复监听
        if (state.cascaderValue?.join(',') == val) {
            return
        }
        if (val) {
            state.cascaderValue = val.split(',').map((item) => parseInt(item))
            setTimeout(async () => {
                if (state.options.length == 0) {
                    await getByLevel()
                }
                if (state.cascaderValue.length > 1) {
                    let list: any = []
                    let checkIndex = 0
                    state.options.forEach((item: any, index: number) => {
                        if (item.value == state.cascaderValue[0]) {
                            checkIndex = index
                            item.loading = false
                            list.push(item)
                        }
                    })
                    await loadData(list)
                    let childrenCheckIndex = 0
                    state.options[checkIndex].children.forEach((item: any, index: number) => {
                        if (item.value == state.cascaderValue[1]) {
                            childrenCheckIndex = index
                            item.loading = false
                            list.push(item)
                        }
                    })
                    await loadData(list)
                    let childrenCheckIndex2 = 0
                    state.options[checkIndex].children[childrenCheckIndex].children.forEach((item: any, index: number) => {
                        if (item.value == state.cascaderValue[2]) {
                            childrenCheckIndex2 = index
                            item.loading = false
                            list.push(item)
                        }
                    })
                    await loadData(list)
                }
            }, 100)
        }
    },
    { immediate: true, deep: true }
)

onMounted(() => {
    getByLevel()
})
// 处理级联选择器的change事件
const handleChange = (idList, value) => {
    // 检查 idList 和 value 是否为 undefined
    if (idList === undefined || value === undefined) {
        emit('update:value', '')
        emit('change', idList, value)
        return // 提前返回，不执行后续代码
    }
    emit('update:value', idList.join(','))
    emit('change', idList, value)
}
// 根据级别获取数据
const getByLevel = async () => {
    let url = '/admin/v1/custgetHangyeFour'
    let requestParam = {
        url: url,
        method: 'get'
    }
    let localData = localStorage.getItem('HangyeFourList3')
    if (localData) {
        state.options = JSON.parse(localData)
    } else {
        baseService(requestParam)
            .then((res) => {
                state.options = res.data.map((item) => {
                    item.isLeaf = false
                    return item
                })
                //先存入本地
                localStorage.setItem('HangyeFourList3', JSON.stringify(state.options))
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('获取失败')
                }
            })
    }
}
// 加载数据
const loadData = async (selectedOptions) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    let type = 'one'
    targetOption.loading = true
    let url = '/admin/v1/custgetHangyeFour'
    if (selectedOptions.length == 1) {
        url = url + `?one=${selectedOptions[selectedOptions.length - 1].value}`
    } else if (selectedOptions.length == 2) {
        type = 'two'
        url = url + `?one=${selectedOptions[selectedOptions.length - 2].value}&two=${selectedOptions[selectedOptions.length - 1].value}`
    } else if (selectedOptions.length == 3) {
        type = 'three'
        url = url + `?one=${selectedOptions[selectedOptions.length - 3].value}&two=${selectedOptions[selectedOptions.length - 2].value}&three=${selectedOptions[selectedOptions.length - 1].value}`
    }
    let requestParam = {
        url: url,
        method: 'get'
    }
    await baseService(requestParam)
        .then((res) => {
            targetOption.children = res.data.map((item: any) => {
                if (type == 'one' || type == 'two') {
                    item.isLeaf = false
                }
                return item
            })
            targetOption.loading = false
            state.options = [...state.options]
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('加载失败')
            }
        })
}
</script>
